import {SHOW_HTML_IN_MENU, SHOW_HIDDEN_FIELDS} from "../../../config/config"

const HMAO_MENU = [
  {
    name: 'geo', title: 'Территориальная схема', number: '01',
    childs: [
      {name: 'geo.objects'},
      {name: 'geo.treads'}
    ]
  },
  {name: 'atu'},
  {name: 'target'},
  {
    name: 'garbage',
    childs: [
      {name: 'garbage.legalEntities'},
      {name: 'garbage.individuals'}
    ]
  },
  {name: 'sourcesWaste'},
  {
    name: 'msn',
    childs: [
      {
        name: 'msn.withContainers'
      },
      {
        name: 'msn.withoutContainers'
      },
      {
        name: 'msn.separateCollections'
      }
    ]
  },
  {
    name: 'unauthorized',
    childs: [
      {
        name: 'unauthorized.heaps'
      },
      {
        name: 'unauthorized.wpf'
      }
    ]
  },
  {name: 'garbageObjectRegistry', title: 'Реестр объектов по обращению с отходами', number: '08'},
  {name: 'registry.operators', title: 'Операторы', number: '09'},
  {name: 'contracts.contracts', title: 'Договоры', number: '10'},
  {name: 'analytic'},
  {
    name: 'classifier.fkko', title: 'Кадастр отходов', number: '12',
    childs: [
      {name: 'classifier.fkko'},
      {name: 'classifier.garbage'}
    ]
  },
  {
    name: 'access',
    childs: [
      {name: 'access.users'},
      {name: 'access.usersGroups'},
      { name: 'access.journals'}
    ]
  },
  {
    href: 'http://billing.panel.demo-tko.etton.ru', title: 'Биллинг', name: 'billing', number: '14'
  },
  {
    name: 'navigationControl',
    childs: (SHOW_HIDDEN_FIELDS ? [
      {name: 'navigationControl.routes'},
      {name: 'navigationControl.routesMap'}
    ] : [
      {name: 'navigationControl.routesMap'}
    ])
  },
  {name: 'waybill'},
  {
    name: 'routes',
    childs: [
      {name: 'routes.routes'},
      {name: 'routes.schedule'}
    ]
  },
  {name: 'carPark'},
  {name: 'staffManagement'},
  {
    name: 'citizen',
    childs: [
      {
        name: 'citizen.appealsMap'
      },
      {
        name: 'citizen.appeals'
      }
    ]
  },
  {
    name: 'calculation',
    childs: [
      {
        name: 'calculation.regionalTariffs'
      }
    ]
  }
]

if (SHOW_HTML_IN_MENU && SHOW_HTML_IN_MENU === true) {
  HMAO_MENU.push({
    name: 'verstka',
    childs: [
      {name: 'verstka.navigationControlPage'},
      {name: 'verstka.navigationControlCarPage'},
      {name: 'verstka.reestr'},
      {name: 'verstka.waybillCard'}
    ]
  })
}

export default HMAO_MENU
